import React, { useState } from 'react';
import classes from "./LoginZipGame.module.css";
import Header from '../../components/Header';
import ZipGameStepperLogin from '../../components/ZipGameStepperLogin';
import { useNavigate } from 'react-router-dom';
import { loginZipUser } from '../../http/http';
import { useDispatch } from 'react-redux';
import { setUserZip } from '../../store/slices/userZipGameTokenSlice';
import { toast } from 'react-toastify';
import { FaArrowLeft } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';

const LoginZipGame = () => {
    const [msisdn, setMsisdn] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const {t}=useTranslation();

    const handleNext = async () => {
        if (!msisdn.trim()) return;

        try {
            // hit here the api for user login

            const response = await loginZipUser(msisdn);
            console.log(response?.data?.result, 'response-');

            if (response?.data?.result?.loginStatus == 1) {


                // user is login success
                navigate("/login/verify-otp/zip-game", {
                    state: { msisdn },
                });
            }
            else {
                // you are not registered!
                toast.error(t("303"));
            }


        } catch (error) {
            console.log(error, 'error-');
            toast.error(error?.response?.data?.message || t("86"));
        }

    };

    return (
        <>
            <Header />

            <div className={classes.container}>

                <div className={classes.header_section}>
                    <div className={classes.back_button} onClick={() => {
                        navigate("/");
                    }}>
                        <FaArrowLeft className={classes.back_icon} />
                    </div>
                </div>


                <div className={classes.heroCard}>
                    <div className={classes.heroBadge}>ZIP GAME</div>
                    <h1 className={classes.heroTitle}>{t("304")}</h1>
                    <p className={classes.heroText}>
                        {t("305")}
                    </p>
                </div>

                <ZipGameStepperLogin currentStep={1} />

                <div className={classes.formCard}>
                    <div className={classes.section}>
                        <div className={classes.sectionHead}>
                            <h2 className={classes.sectionTitle}>{t("306")}</h2>
                            <p className={classes.sectionText}>
                                {t("307")}
                            </p>
                        </div>

                        <div className={classes.inputGroup}>
                            <label className={classes.label} htmlFor="msisdn">
                                {t("308")}
                            </label>

                            <div className={classes.phoneField}>
                                <div className={classes.countryBox}>
                                    <img
                                        src="/assets/images/flag.png"
                                        alt="flag"
                                        className={classes.flag}
                                    />
                                    <span className={classes.code}>+245</span>
                                </div>

                                <input
                                    id="msisdn"
                                    type="number"
                                    className={classes.input}
                                    placeholder={t("309")}
                                    value={msisdn}
                                    onChange={(e) => setMsisdn(e.target.value)}
                                    onWheel={(e) => e.target.blur()}
                                />
                            </div>
                        </div>

                        <div className={classes.infoBox}>
                            <p>
                                {t("310")}
                            </p>
                        </div>

                        <button type="button" className={classes.primaryBtn} onClick={() => handleNext()}>
                            {t("311")}
                        </button>

                        {/* here it will be the register option */}
                        <p className={classes.link_text}>
                            {t("312")}{" "}<span onClick={() => navigate("/register/zip-game")}>{t("313")}</span>
                        </p>

                    </div>
                </div>
            </div>
        </>
    )
}

export default LoginZipGame